// extracted by mini-css-extract-plugin
export default {"main":"GoBackLink_main__nhc4p"};